<template>
  <div>
    <Card>
      <List item-layout="vertical" :loading="loading">
        <ListItem v-for="item in data" :key="item.site_id">
          <ListItemMeta>
            <span slot="title">
              <span>系统：</span>
              <a style="color: #2d8cf0">{{ item.domain }}</a>
            </span>
          </ListItemMeta>
          <span>
            <span>访客数：<b>{{ item.uv }}</b></span>
          </span>
        </ListItem>
      </List>
    </Card>
  </div>
</template>

<script>
import { getPolarisBaseAnalyseSite } from '@/api/opscenter'

export default {
  name: 'polaris_base',
  props: {
    start_date: {
      type: String,
      default: null
    },
    end_date: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      loading: false,
      data: [
        {
          domain: '北极星',
          uv: 0
        }
      ]
    }
  },
  created: function () {
    this.getTableData()
  },
  methods: {
    getTableData () {
      let params = {
        start_date: this.start_date,
        end_date: this.end_date
      }
      this.loading = true
      getPolarisBaseAnalyseSite(params).then(res => {
        this.data[0].uv = res.data.uv
        this.loading = false
      }).catch(res => {
        this.loading = false
        console.error(res.response)
      })
    }
  }
}
</script>

<style scoped>

</style>
